import { render, staticRenderFns } from "./RoadmapsView.vue?vue&type=template&id=1ca51c70&"
import script from "./RoadmapsView.vue?vue&type=script&lang=js&"
export * from "./RoadmapsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports